<template>
  <a-modal title="添加科室" :width="900" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    v-if="hackReset" @cancel="handleCancel" @ok="addList">
    <div class="viewDetial-tiem">
      <a-form layout="inline">
        <a-row>
          <a-col>
            <a-form-item label="*医院">
              <!-- <a-input v-model="queryParam.status" allow-clear placeholder="请输入状态"/> -->
              <a-select style="width:200px" v-model="queryParam.orgId" placeholder="请选择医院" :options="recipeStatus">
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="上级科室">
              <a-tree-select v-model="queryParam.parentId" style="width: 200px"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="parentOptions"
                placeholder="请先选择医院" @change="parentChange">
              </a-tree-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="*科室名称">
              <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入科室名称" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="科室负责人">
              <a-input v-model="queryParam.linkman" allow-clear placeholder="请输入科室负责人" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="负责人电话">
              <a-input v-model="queryParam.phone" allow-clear placeholder="请输入负责人电话" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="科室位置">
              <a-input v-model="queryParam.position" allow-clear placeholder="请输入科室位置" />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row>
                <a-col>
                    <a-form-item label="科室类型">
                        <a-radio-group v-model="queryParam.radio" name="radioGroup">
                            <a-radio value="1">互联网医院科室</a-radio>
                            <a-radio value="2">门诊科室</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row> -->
        <a-row>
          <a-col>
            <a-form-item label="科室描述">
              <a-input v-model="queryParam.deptDesc" allow-clear placeholder="请输入科室描述" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="监管对应诊疗科目名称">
              <a-select style="width:200px" v-model="queryParam.deptClassCode" placeholder="请选择监管对应诊疗科目名称"
                :options="classOption"></a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="状态">
              <a-radio-group v-model="queryParam.useflag" name="status">
                <a-radio value="1">正常</a-radio>
                <a-radio value="2">停用</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
  import { STable  } from '@/components';
  // import { ACascader } from '@/node_modules/ant-design-vue/types/cascader'
  import moment from 'moment'
  import { inquiryorderSelect , departmentAdd , getParentDepartment , getClassDepartment } from '@/api/modular/interhospital/hlwyyDepartment/hlwyyDepartmentManage'
  export default {
    components:{
      STable
    },
    data () {
      return {
        queryParam : {
          useflag : '1'
        },
        visible: false,
        hackReset : true,

        refuse : false,
        refuseReason : '',

        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        verifytimeDateString: '',
        
        confirmLoading: false,
        form: this.$form.createForm(this),
        recipeStatus : [],
        parentOptions : [],
        classOption : [],

      }
    },
    created(){
      
    },
    watch:{
      'queryParam.orgId'(newVal,oldVal){
        this.getParentList(newVal)
      },
      'queryParam.parentId'(newVal,oldVal){
      }
    },
    methods: {
      moment,
      // 初始化方法
      add (record,kg) {
        this.kg = !kg;
        this.visible = true;
        this.getSelect();
        this.getClass();
      },
      // 获取 筛选条件 下拉框
      getSelect(){
        inquiryorderSelect().then(res=>{
          this.recipeStatus = [];
          res.data.map((item,index)=>{
            this.recipeStatus.push({
              label : item.orgName,
              value : item.orgId
            })
            this.queryParam.orgId =  "1"
          })
          
        })
      },
      // 获取科目
      getClass(){
        this.classOption = [];
        getClassDepartment().then(res=>{
          if(res.code == 200){
            res.data.map((item,index)=>{
              this.classOption.push({
                label : item.detailName,
                value : item.detailValue,
              })
            })
          }else{
            this.classOption = [];
          }
        })
      },
      // 获取父级科室
      getParentList(orgId){
          let params = {
            orgId ,
          }
          this.parentOptions = [];
          getParentDepartment(params).then(res=>{
            if(res.code == 200){
              this.parentOptions =  this.recursion(res.data);
            }
          })
      },
      recursion(arr){
        arr.forEach((item,index)=>{
          if(item.childDepartments instanceof Array){
              arr[index] = {
                title : item.deptName,
                value : item.deptId,
                key : item.deptId,
                children :  item.childDepartments
              }
              this.recursion(item.childDepartments)
          }else{
            arr[index] = {
              title : item.deptName,
              value : item.deptId,
              key : item.deptId,
              children :  []
            }
          }
          
        })
        return arr
      },
      addList(){
        if(!this.queryParam.orgId){
          this.$message.error('医院不能为空');
          return
        }
        if(!this.queryParam.deptName){
          this.$message.error('科室名称不能为空');
          return
        }
        departmentAdd(this.queryParam).then(res=>{
          if (res.code == 200) {
            this.visible = false;
            this.$message.success('添加成功');
            this.$parent.handleOk();
            this.queryParam = {};
          } else {
            this.$message.error('添加失败')
          }
        })
      },
      //点击取消按钮
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      parentChange(value) {
        
      },
    },
  }
</script>
<style lang="less" scoped>
/deep/.ant-col .ant-form-item-label{
    width: 155px;
}
</style>
